module.exports = __webpack_public_path__ + "img/group-161@2x.1c6113d3.webp";